<template>
    <div class="order scrollable-div">
        <div>
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    name: 'order',
}
</script>